'use strict';

var EventEmitter = require('events').EventEmitter,
    assign = require('object-assign'),
    SchedulerAppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    CHANGE_EVENT = 'change',
    KEY_IS_BREWING_NOTES_OPEN = 'is_brewing_notes_open',
    KEY_IS_PACKAGING_NOTES_OPEN = 'is_packaging_notes_open',
    ActionTypes = require('constants/AppConstants').ActionTypes,
    ContentUtils = require('utils/ContentUtils'),
    UIStateStore;

/**
 * The persistence state of UI.
 */
UIStateStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    removeChangeListener: function (call) {
        this.removeListener(CHANGE_EVENT, call);
    },

    addChangeListener: function (call) {
        this.on(CHANGE_EVENT, call);
    },

    isBrewingNotesBarOpen: function () {
        return ContentUtils.getLocal(KEY_IS_BREWING_NOTES_OPEN);
    },

    isPackagingNotesBarOpen: function () {
        return ContentUtils.getLocal(KEY_IS_PACKAGING_NOTES_OPEN);
    },

    openBrowingNotesBar: function () {
        ContentUtils.saveLocal(KEY_IS_BREWING_NOTES_OPEN, true);
    },

    closeBrowingNotesBar: function () {
        ContentUtils.saveLocal(KEY_IS_BREWING_NOTES_OPEN, false);
    },

    openPackagingNotesBar: function () {
        ContentUtils.saveLocal(KEY_IS_PACKAGING_NOTES_OPEN, true);
    },

    closePackagingNotesBar: function () {
        ContentUtils.saveLocal(KEY_IS_PACKAGING_NOTES_OPEN, false);
    }
});

UIStateStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {

    switch (action.type) {
        case ActionTypes.CLICK_SHOW_SIDEBAR:
            break;

        default:
    }
});

module.exports = UIStateStore;



/** WEBPACK FOOTER **
 ** ./src/stores/UIStateStore.js
 **/